// extracted by mini-css-extract-plugin
export default {"mainWrapper":"TermsOfUse_mainWrapper__Th7tg","mainContainer":"TermsOfUse_mainContainer__YX51F","mainContent":"TermsOfUse_mainContent__Rue7Z"};